import InventoryIcon from "@mui/icons-material/Inventory";
import GroupIcon from "@mui/icons-material/Group";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import { Badge, Avatar } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions"; // <-- added
// import

const MenuItems = ({
  role,
  unreadOrders = 0,
  visitedSections,
  adminData,
  unseenCount,
  newOrderCount,
  kitchenOrderCount = 0,
  newQrOrderCount,
}) => {
  const adminInfo = adminData?.data || adminData;

  const getAvatarContent = () => {
    if (!adminInfo) return <PersonIcon fontSize="small" />;
    return adminInfo.admin_name?.charAt(0) || "U";
  };

  const getAvatarWithBadge = () => {
    if (role === "super_admin") {
      return (
        <Avatar
          alt={adminInfo?.admin_name || "User"}
          sx={{
            width: 24,
            height: 24,
            bgcolor: "primary.main",
            fontSize: "0.875rem",
          }}
        >
          {getAvatarContent()}
        </Avatar>
      );
    }

    return (
      <Badge
        variant="dot"
        color="error"
        overlap="circular"
        invisible={unseenCount === 0}
      >
        <Avatar
          alt={adminInfo?.admin_name || "User"}
          sx={{
            width: 24,
            height: 24,
            fontSize: "0.875rem",
          }}
        >
          {getAvatarContent()}
        </Avatar>
      </Badge>
    );
  };

  const commonProfileItem = {
    text: "Profile",
    icon: getAvatarWithBadge(),
  };

  const orderManagementItem = {
    text: "Order Management",
    icon: (
      <Badge
        badgeContent={newOrderCount > 0 ? newOrderCount : null}
        color="error"
        invisible={newOrderCount === 0}
      >
        <ShoppingCartIcon />
      </Badge>
    ),
  };

  const kitchenItem = {
    text: "Kitchen",
    icon: (
      <Badge badgeContent={kitchenOrderCount || unreadOrders} color="error" invisible={kitchenOrderCount === 0 && (!unreadOrders || visitedSections.kitchen)}>
        <RestaurantIcon />
      </Badge>
    ),
  };

  const tableManagementItem = {
    text: "Book Table",
    icon: <TableRestaurantIcon />,
  };

  const itemManagementItem = {
    text: "Item Management",
    icon: <InventoryIcon />,
  };
  const mainCourses = {
    text: "Main Course",
    icon: <InventoryIcon />,
  };


  const enquiryManagementItem = {
    text: "Enquiry Management",
    icon: <ContactSupportIcon />,
  };

  const staffManagementItem = {
    text: "Staff Management",
    icon: <GroupIcon />,
  };

  const deliveryManagementItem = {
    text: "Delivery Management",
    icon: <DeliveryDiningIcon />,
  };

  const billingItem = {
    text: "Billing Report",
    icon: <ReceiptIcon />,
  };

  const subscriptionItem = {
    text: "Subscription", 
    icon: <SubscriptionsIcon />,
  };

  const QrOrderItems = {
    text: "Qr Order",
    icon: (
      <Badge
        badgeContent={newQrOrderCount > 0 ? newQrOrderCount : null}
        color="error"
        invisible={visitedSections.qrOrder || newQrOrderCount === 0}
      >
        <ShoppingCartIcon />
      </Badge>
    ),
  };

  const roleBasedMenu = {
    super_admin: [
      commonProfileItem,
      staffManagementItem,
      itemManagementItem,
      mainCourses,
      orderManagementItem,
      enquiryManagementItem,
      tableManagementItem,
      kitchenItem,
      deliveryManagementItem,
      billingItem,
      subscriptionItem, // added for super_admin
      QrOrderItems
     
    ],
    admin: [
      commonProfileItem,
      staffManagementItem,
      itemManagementItem,
      mainCourses,
      orderManagementItem,
      enquiryManagementItem,
      tableManagementItem,
      kitchenItem,
      deliveryManagementItem,
      subscriptionItem, // added for admin
      QrOrderItems
     
    ],
    kitchen: [commonProfileItem, itemManagementItem, kitchenItem],
    cashier: [
      commonProfileItem,
      orderManagementItem,
      tableManagementItem,
      billingItem,
    ],
    waiter: [commonProfileItem, orderManagementItem, tableManagementItem],
    rider: [commonProfileItem, orderManagementItem],
  };

  return roleBasedMenu[role] || [];
};

export default MenuItems;
